import { render, staticRenderFns } from "./ManageContactusMail.vue?vue&type=template&id=15b278bf"
import script from "./ManageContactusMail.vue?vue&type=script&lang=js"
export * from "./ManageContactusMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports